<p>Portfolio #{{portfolioData.key}}</p>
<br>
<p>Inversión #{{portfolioData.inversion}}</p>

 <div class="div-graph">
<plotly-plot *ngIf="isDataAvailable" [data]="data" [layout]="layout" [useResizeHandler]="true"></plotly-plot>
 </div>

